import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: React.ReactNode;
  variant?: 'solid' | 'glass';
  className?: string;
  onClick?: () => void;
}
export function Card({
  children,
  variant = 'solid',
  className = '',
  onClick
}: CardProps) {
  const baseClasses = 'rounded-2xl p-6 transition-all duration-300';
  const variantClasses = variant === 'glass' ? 'bg-white/70 backdrop-blur-xl border border-white/50 shadow-sm' : 'bg-white shadow-md border border-slate-100';
  if (onClick) {
    return <motion.div whileHover={{
      y: -4,
      boxShadow: '0 10px 30px -10px rgba(0,0,0,0.1)'
    }} whileTap={{
      scale: 0.98
    }} onClick={onClick} className={`${baseClasses} ${variantClasses} cursor-pointer ${className}`} data-id="element-11">
        {children}
      </motion.div>;
  }
  return <div className={`${baseClasses} ${variantClasses} ${className}`} data-id="element-12">
      {children}
    </div>;
}